/* NPM */
import { useMemo } from "react";
import cx from "classnames";
/* UTILS */
import {
  DURATION_COUNT,
  OFFER_PLAN_NAME,
  SPECIAL_OFFER,
  RAMP1_MEDS_SUBLABEL,
  CONSULT_FEE_LABEL,
  TEMP_MEDS_SUBLABEL
} from "../../../../constants";
import t from "utils/translate";
/* COMPONENTS */
import Column from "../../../../../Column";
/* STYLES */
import styles from "./styles.module.scss";

const SimpleOfferCard = ({ plan = {}, onSelection, selected }) => {
  const {
    contentMap,
    formattedSalePrice,
    formattedRamp2SalePrice,
    ramp2SalePrice,
    salePrice,
    clinical
  } = plan;

  const onClick = () => {
    onSelection(plan);
  };

  const {
    specialOffer,
    offerPlanName,
    durationLabel,
    ramp1MedsSublabel,
    hasConsultFee,
    price
  } = useMemo(() => {
    const ramp1MedsSublabel = contentMap.get(RAMP1_MEDS_SUBLABEL);
    const consultFeeLabel = contentMap.get(CONSULT_FEE_LABEL);
    const addonSalePrice = clinical?.salePrice || "";
    const unformattedAddonSalePrice = clinical?.unformattedSalePrice || 0;

    return {
      specialOffer: contentMap.get(SPECIAL_OFFER),
      offerPlanName: contentMap.get(OFFER_PLAN_NAME),
      durationLabel: contentMap.get(DURATION_COUNT)?.toLowerCase(),
      ramp1MedsSublabel,
      consultFeeLabel,
      hasConsultFee:
        consultFeeLabel && addonSalePrice && unformattedAddonSalePrice > 0,
      price:
        ramp1MedsSublabel &&
        formattedRamp2SalePrice &&
        parseInt(ramp2SalePrice, 10) > parseInt(salePrice, 10)
          ? formattedRamp2SalePrice
          : formattedSalePrice
    };
  }, [contentMap, formattedSalePrice, formattedRamp2SalePrice, clinical]);

  return (
    <Column
      className={cx(styles.simpleContent, {
        [styles.selected]: selected,
        [styles.hasSpecialOffer]: specialOffer
      })}
      role="button"
      onClick={onClick}
      data-testid={`simple-offer-card-${offerPlanName}`}
    >
      {specialOffer && (
        <div className={styles.specialOffer}>{specialOffer}</div>
      )}
      <div className={styles.details}>
        <h3 className={styles.offerPlanName}>{offerPlanName}</h3>
        <p className={styles.formattedSalePrice}>
          {price}/{durationLabel}
        </p>
      </div>
      {ramp1MedsSublabel && (
        <div className={styles.ramp1MedsSublabel}>
          {hasConsultFee ? t(TEMP_MEDS_SUBLABEL) : ramp1MedsSublabel}
        </div>
      )}
    </Column>
  );
};

export default SimpleOfferCard;
